var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},_vm._l((5),function(idx){return _c('span',{key:idx},[(_vm.rating < idx)?_c('img',{attrs:{"src":require("../assets/GrayStar.svg")}}):_c('img',{attrs:{"src":require("../assets/RedStar.svg")}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }